export var FEATURE_FLAGS_V5 = /*#__PURE__*/function (FEATURE_FLAGS_V5) {
  FEATURE_FLAGS_V5["MODULE_HANA_AI"] = "MODULE_HANA_AI";
  FEATURE_FLAGS_V5["HIDE_TALENT_MODULES"] = "HIDE_TALENT_MODULES";
  FEATURE_FLAGS_V5["HIDE_HRIS_MODULES"] = "HIDE_HRIS_MODULES";
  FEATURE_FLAGS_V5["ENABLE_SOCIAL_HUB_NEWS"] = "ENABLE_SOCIAL_HUB_NEWS";
  FEATURE_FLAGS_V5["ENABLE_HANA_END_USER"] = "ENABLE_HANA_END_USER";
  FEATURE_FLAGS_V5["ATS_LAUNCH"] = "ATS_LAUNCH";
  FEATURE_FLAGS_V5["ATS_LAUNCH_STAKEHOLDER"] = "ATS_LAUNCH_STAKEHOLDER";
  FEATURE_FLAGS_V5["TALENT_SIDE_MENU_NAVIGATION_V2"] = "TALENT_SIDE_MENU_NAVIGATION_V2";
  FEATURE_FLAGS_V5["ENABLE_HRIS_GROUPS_MODULE"] = "ENABLE_HRIS_GROUPS_MODULE";
  FEATURE_FLAGS_V5["LEARNING_FOUNDATION_LIDER"] = "LEARNING_FOUNDATION_LIDER";
  return FEATURE_FLAGS_V5;
}({});
export var FEATURE_FLAGS_V5_KEYS = /*#__PURE__*/Object.values(FEATURE_FLAGS_V5);